module.exports = __webpack_public_path__ + "static/media/hz6.7da2b00e.png";